import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearRightSidePanelInteriorProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function RearRightSidePanelInterior(props: RearRightSidePanelInteriorProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Rear Right Side Panel"
      width={275}
      height={43}
      viewBox="0 0 275 43"
      position={{top: 0, right: 107}}
    >
      <path
        d="M274 42.0021C266.083 40.3639 248.95 31.5015 234 25.0012C211 15.0007 170 2.00001 148 0.999954L0 1.00005C27 1.00005 60 12 60 30C60 31.7486 59.637 33.4113 58.9406 35C162.893 35 253.5 37.7605 274 42.0021Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M148 0.999954C170 2.00001 211 15.0007 234 25.0012C248.95 31.5015 266.083 40.3639 274 42.0021C249.2 36.8038 120.294 35.168 58.9406 35C59.637 33.4113 60 31.7486 60 30C60 12 27 1.00005 0 1.00005C67.5607 1.00001 80.4393 0.99999 148 0.999954ZM148 0.999954L150 1.00005"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M59 24.6956C152.031 26.1719 226 28.8695 247 30.9565"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
